/**
 * @generated SignedSource<<a7d7b635a9d3546cec58c587ab2ed00e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type GraphQLLlmInteractionStatus = "COMPLETED" | "FAILED" | "INTERRUPTED" | "IN_PROGRESS" | "PENDING" | "SKIPPED" | "%future added value";
export type GraphQLMessageMessageRole = "AGENT" | "HUMAN" | "%future added value";
export type GraphQLMessageMessageType = "AGENT_PROCESS" | "AGENT_RESPONSE" | "ERROR_RESPONSE" | "USER_INPUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EmbeddedChat_conversation$data = {
  readonly id: any;
  readonly llmInteractions: ReadonlyArray<{
    readonly id: any;
    readonly status: GraphQLLlmInteractionStatus;
    readonly statusMessage: string | null | undefined;
  }>;
  readonly messages: ReadonlyArray<{
    readonly content: string;
    readonly id: string;
    readonly messageMetadata: {
      readonly usage: {
        readonly billingTokens: number;
      } | null | undefined;
    } | null | undefined;
    readonly messageRole: GraphQLMessageMessageRole;
    readonly messageType: GraphQLMessageMessageType | null | undefined;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"LlmConversationMessageList_llmConversation">;
  readonly " $fragmentType": "EmbeddedChat_conversation";
};
export type EmbeddedChat_conversation$key = {
  readonly " $data"?: EmbeddedChat_conversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmbeddedChat_conversation">;
};

import EmbeddedChatConversationRefetchQuery_graphql from './EmbeddedChatConversationRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": EmbeddedChatConversationRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "EmbeddedChat_conversation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 10
        }
      ],
      "concreteType": "GraphQLLlmInteraction",
      "kind": "LinkedField",
      "name": "llmInteractions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusMessage",
          "storageKey": null
        }
      ],
      "storageKey": "llmInteractions(last:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLFormattedMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLMessageMetadata",
          "kind": "LinkedField",
          "name": "messageMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLUsageTokens",
              "kind": "LinkedField",
              "name": "usage",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billingTokens",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LlmConversationMessageList_llmConversation"
    }
  ],
  "type": "GraphQLLlmConversation",
  "abstractKey": null
};
})();

(node as any).hash = "cf58e7db9478f6d1cb6fdaa8a697b47f";

export default node;
